import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SocialBar from '../components/SocialBar';

function MainLayout({ children }) {
  return (
    <>
      <Navbar />
      <SocialBar />

      <main>
        {children}
      </main>

      <Footer />
    </>
  );
}

export default MainLayout;
